module.exports = __webpack_public_path__ + "img/destination.8a1fff9f.svg";